import { render, staticRenderFns } from "./PointTime.vue?vue&type=template&id=351c11ad&scoped=true"
import script from "./PointTime.vue?vue&type=script&lang=js"
export * from "./PointTime.vue?vue&type=script&lang=js"
import style0 from "./PointTime.vue?vue&type=style&index=0&id=351c11ad&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351c11ad",
  null
  
)

export default component.exports